import React, { Component } from 'react'; // eslint-disable-line
import axios from 'axios';
import StaticBrand from '../assets/images/svg/m1-logo-public.svg';
import '../assets/styles/landing.css';
import ClayPhone from '../assets/images/m1-phone.png';
// import '../assets/landing/landing.css';
import pin from '../assets/images/map-marker.png';

require('typeface-open-sans');

class Landing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            config: {},
            loading: true,
        };
        this.getConfig = this.getConfig.bind(this);
    }

    componentDidMount() {
        this.getConfig();

        const gtag = document.createElement('script');
        gtag.src = 'https://www.googletagmanager.com/gtag/js?id=UA-151181836-1';
        gtag.async = true;
        const gtag2 = document.createElement('script');
        gtag2.innerHTML = `window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'UA-151181836-1');`;
        document.head.appendChild(gtag);
        document.head.appendChild(gtag2);
    }

    getConfig() {
        if (typeof window.GENESIS_CMS_API_URL !== 'undefined') {
            axios.get(`${window.GENESIS_CMS_API_URL}/v2/projects/config/?hashId=${this.props.match.params.orgId}&forCMS=true`)
                .then((response) => {
                    this.setState({
                        config: response.data.data,
                        loading: false,
                    });
                })
                .catch(() => {
                    this.setState({
                        config: {},
                        loading: false,
                    });
                });
        } else {
            setTimeout(this.getConfig, 50);
        }
    }

    getCTAText() {
        const CTAStrings = [
            { moduleType: 2, text: ' browse the latest sermons' },
            { moduleType: 4, text: ' register for events' },
            { moduleType: 6, text: ' watch church live-streams' },
            { moduleType: 7, text: ' utilize child check-in' },
            { moduleType: 5, text: ' contact us' },
            { moduleType: 1, text: " see what's going on at your church" },
            { moduleType: 8, text: ' view ShareFaith Kids Devotionals' },
            { moduleType: 3, text: ' view your donation history' },
            { moduleType: 9, text: ' view your directory' },
            { moduleType: 10, text: ' view your calendar' },
        ];
        const CTAEnd = ' and more all with the convenience of your phone.';
        let result = this.state.config.modules.map((module) => {
            return module.moduleType < 11 ? CTAStrings.find((s) => { return module.moduleType === s.moduleType; }).text : '';
        });
        result[0] = result[0].trim();
        result[0] = result[0].charAt(0).toUpperCase() + result[0].slice(1);
        result = result.slice(0, 3);
        return result.toString() + CTAEnd;
    }

    getChurchInitials = (church) => { // eslint-disable-next-line
        if(typeof church != 'undefined') {
            return church.split(' ')
                .map((x) => { return x[0]; })
                .join('')
                .substring(0, 4);
        }
        return '';
    }

    render() {
        if (!this.state.config.app && !this.state.loading) {
            return (
                <div className="landing-page">
                    <h1>
                        Oops, this is not a valid page.
                        <br />
                        <svg width="122px" height="128px" viewBox="0 0 122 128" version="1.1" xmlns="http://www.w3.org/2000/svg">
                            <defs>
                                <filter x="0.0%" y="0.0%" width="100.0%" height="100.0%" filterUnits="objectBoundingBox" id="filter-1">
                                    <feGaussianBlur stdDeviation="0" in="SourceGraphic" />
                                </filter>
                            </defs>
                            <g id="Unviversal-Pages" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                <g id="search-text-based-error-not-found" transform="translate(-128.000000, -190.000000)">
                                    <g id="sad-search" transform="translate(128.000000, 191.000000)">
                                        <g id="Group-2" transform="translate(14.000000, 0.000000)">
                                            <path d="M73.2,71.5664071 L95.9515025,91.1662422" id="Oval-5" stroke="#343434" strokeWidth="2" fill="#FFFFFF" />
                                            <ellipse id="Oval-5" stroke="#343434" strokeWidth="2" cx="42.6" cy="42.6992849" rx="42.6" ry="42.6992849" />
                                            <g id="Group-3" transform="translate(19.000000, 38.000000)">
                                                <g id="Group-5" transform="translate(2.000000, 0.000000)" fill="#343434">
                                                    <circle id="Oval-6" cx="4.49090909" cy="4.27042746" r="4" />
                                                    <circle id="Oval-6" cx="40.4909091" cy="4.27042746" r="4" />
                                                </g>
                                                <path d="M33,25 C30.7101177,22.5314357 27.5199181,21 23.5263158,21 C20.4717548,21 17.2886508,22.523827 15,25" id="Oval-7" stroke="#343434" strokeWidth="2" strokeLinecap="round" />
                                                <path d="M5,25 C7.76142375,25 10,22.8121085 10,20 C10,18.2762044 8.33333333,15.2762044 5,11 C1.66666667,15.2762044 0,18.2762044 0,20 C0,22.8121085 2.23857625,25 5,25 Z" id="Tear" fill="#00E5FF" />
                                            </g>
                                        </g>
                                        <ellipse id="Oval-8" fill="#E6EBF2" filter="url(#filter-1)" cx="59" cy="124" rx="40" ry="3" />
                                        <circle id="Oval-3" fill="#C7DBFF" opacity="0.300000012" cx="116" cy="21" r="6" />
                                        <circle id="Oval-3" fill="#C7DBFF" opacity="0.300000012" cx="6" cy="82" r="6" />
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </h1>
                </div>
            );
        }
        return (
            <div className="landing-page">
                { this.state.config && this.state.config.app
                && (
                    <div className="landing-page-content">
                        <div className="landing-logo">
                            {this.state.config.app.churchLogoURL
                                ? <img src={this.state.config.app.churchLogoURL} />
                                : <div className="initial-logo">{this.getChurchInitials(this.state.config.app.organizationName)}</div>}
                        </div>
                        <h1 data-qa="landing-org-name">{this.state.config.app.organizationName}</h1>
                        <div className="divider" />
                        <div className="stay-connected">
                            <div className="preview"><img src={ClayPhone} /></div>
                            <div className="cta">
                                <h2>Stay Connected with Our App</h2>
                                <p>{this.getCTAText()}</p>
                                <div className="m1logo"></div>
                                <iframe
                                    src={`${`${window.GENESIS_CMS_API_URL}/v2`}/organizations/organization/embed/contents?organizationId=${this.state.config.app.genesisOrganizationID}`}
                                    scrolling="no"
                                    height="48"
                                    width="275"
                                    frameBorder="0"
                                    marginHeight="0"
                                    marginWidth="0"
                                />
                            </div>
                        </div>
                        <div className="page-break" />
                        <div className="description">
                            <p data-qa="landing-org-description">{this.state.config.app.description}</p>
                        </div>
                        <div className="location">
                            <h2>LOCATION</h2>
                            <p data-qa="landing-org-address">
                                {this.state.config.app.churchStreetAddress},
                                {this.state.config.app.churchCity},
                                {this.state.config.app.churchState},
                                {this.state.config.app.churchZip}
                            </p>
                        </div>
                        <div className="map">
                            <img src={`https://maps.googleapis.com/maps/api/staticmap?center=${this.state.config.app.churchLatitude},${this.state.config.app.churchLongitude}&zoom=13&size=600x300&maptype=roadmap&markers=anchor:center%7Cicon:${`${window.location.protocol}//${window.location.host}${pin}`}%7C${this.state.config.app.churchLatitude},${this.state.config.app.churchLongitude}&key=${window.MAPS_API}`} />
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default Landing;
